import { SocialLoginError, SocialLoginErrorCodeEnum } from '.';

interface ILoginErrorMessageProps {
	title: string;
	description?: string;
}

export function getSocialLoginErrorMessage(
	err: unknown,
	t: (key: string) => string
): ILoginErrorMessageProps {
	let title = t('error.login_failed.title');
	let description = t('error.login_failed.description');

	if (err instanceof SocialLoginError) {
		switch (err.code) {
			case SocialLoginErrorCodeEnum.GOOGLE_ADD_ACCOUNT:
				title = t('error.google.add_account_title');
				description = t('error.google.add_account_description');
				break;
			case SocialLoginErrorCodeEnum.USER_NOT_FOUND:
				title = t('error.user_not_found.title');
				description = t('error.user_not_found.description');
				break;
			case SocialLoginErrorCodeEnum.DIFFERENT_CREDENTIAL_EXISTS:
				title = t('error.facebook.link_pending_account_title');
				description = t('error.facebook.link_pending_account_description');
				break;

			default:
				break;
		}
	}

	return { title, description };
}
